import styled from 'styled-components';

export const IconsWrapper = styled.div.attrs<{ className?: string }>({
  className: 'min-h-11 justify-end max-md:justify-start md:h-[60px]',
})`
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  overflow: visible !important;
`;
